import { theme } from "antd";
import { useContext } from "react";
import { AppContext } from "../App";

/**
 * Hook para acceder fácilmente a los tokens de diseño de Ant Design
 * Incluye tokens configurables adicionales (roleColors, semanticColors, etc.)
 *
 * @returns {Object} Tokens de diseño incluyendo colorPrimary, borderRadius, fontSize, etc.
 */
export const useThemeTokens = () => {
  const { token } = theme.useToken();
  const { state } = useContext(AppContext);

  return {
    // Colores principales
    colorPrimary: token.colorPrimary,
    colorSuccess: token.colorSuccess,
    colorWarning: token.colorWarning,
    colorError: token.colorError,
    colorInfo: token.colorInfo,

    // Fondos
    colorBgContainer: token.colorBgContainer,
    colorBgElevated: token.colorBgElevated,
    colorBgLayout: token.colorBgLayout,

    // Bordes
    borderRadius: token.borderRadius,
    borderRadiusLG: token.borderRadiusLG,
    borderRadiusSM: token.borderRadiusSM,
    borderColor: token.borderColor,
    borderColorSplit: token.borderColorSplit,

    // Tipografía
    fontSize: token.fontSize,
    fontSizeLG: token.fontSizeLG,
    fontSizeSM: token.fontSizeSM,
    fontSizeXL: token.fontSizeXL,
    fontFamily: token.fontFamily,
    fontWeightStrong: token.fontWeightStrong,

    // Espaciado
    padding: token.padding,
    paddingLG: token.paddingLG,
    paddingSM: token.paddingSM,
    paddingXS: token.paddingXS,
    margin: token.margin,
    marginLG: token.marginLG,
    marginSM: token.marginSM,
    marginXS: token.marginXS,

    // Sombras
    boxShadow: token.boxShadow,
    boxShadowSecondary: token.boxShadowSecondary,

    // Control heights
    controlHeight: token.controlHeight,
    controlHeightLG: token.controlHeightLG,
    controlHeightSM: token.controlHeightSM,

    // Otros tokens útiles
    lineHeight: token.lineHeight,
    lineHeightLG: token.lineHeightLG,
    lineHeightSM: token.lineHeightSM,

    // Colores configurables adicionales desde el estado
    roleColors: state?.roleColors || {},
    semanticColors: state?.semanticColors || {},
    gradientColors: state?.gradientColors || {},
    statusColors: state?.statusColors || {},

    // Algoritmo (dark/light)
    algorithm: state?.algorithm || "light",

    // Retornar todos los tokens por si se necesitan
    ...token,
  };
};
